/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

export function dispatchGtmEvent(event, step) {
  if (!window) return;
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ event, step });
}
